import { safeNumber } from '../../utils/numbers'
import {
  CANCELLATION,
  LATE_ORDER,
  LATE_TESTING,
  OTHER_FEES,
} from '../../constants/FundingConstants'

const getIncludedFeesAsCSV = feeTypeSubsidies => {
  const includedFees = []
  if (feeTypeSubsidies?.cancellation?.active) {
    includedFees.push(OTHER_FEES[CANCELLATION])
  }
  if (feeTypeSubsidies?.lateTesting?.active) {
    includedFees.push(OTHER_FEES[LATE_TESTING])
  }
  if (feeTypeSubsidies?.lateOrder?.active) {
    includedFees.push(OTHER_FEES[LATE_ORDER])
  }
  if (includedFees.length === 0) return 'None'
  return includedFees.join(', ')
}

const SelectedSubsidiesTable = ({ examPricing, subsidies, title }) => (
  <>
    {safeNumber(subsidies?.amount) > 0 ? (
      <>
        <dt>{title}</dt>
        <dd>
          <table className="table">
            <thead>
              <tr>
                <th>Taking Course?</th>
                <th>Other Fees</th>
                <th>State Pays</th>
                <th>District Funding</th>
                <th>School Pays</th>
              </tr>
            </thead>
            <tbody>
              {safeNumber(subsidies?.amount) > 0 ? (
                <tr>
                  <td>{subsidies?.courseTaken ? 'Yes' : 'No'}</td>
                  <td>{getIncludedFeesAsCSV(subsidies?.feeTypeSubsidies)}</td>
                  <td>${safeNumber(examPricing?.stateFunding)}</td>
                  <td>${safeNumber(subsidies?.amount)}</td>
                  <td>
                    $
                    {safeNumber(examPricing?.testPrice) -
                      safeNumber(examPricing?.stateFunding) -
                      safeNumber(subsidies?.amount)}{' '}
                    + applicable fees
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </dd>
      </>
    ) : null}
  </>
)

export default SelectedSubsidiesTable
